export default __webpack_public_path__ + "static/media/placeholder_dummy2016-schneiderei01-mobile-de.c1ae53aa.png";